import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import SubjectOutlinedIcon from "@material-ui/icons/SubjectOutlined";
import NotesOutlinedIcon from "@material-ui/icons/NotesOutlined";
import { consulta, formulario, mostrarError, obtenerPermisosValorAlt, obtenerValoresFiltros } from "../../../global/js/funciones";
import TareasTerminadas from "../../general/TareasTerminadas";
import emma_s1 from "./../../../global/imagenes/emma_s1.png";
import { PlaneadorShell, PlaneadorTopBar, PlaneadorMenuView, PlaneadorInfoGeneralView, PlaneadorUnidadView, PlaneadorSemanaView, PlaneadorObservacionesView } from "./components/PlaneadorViews";
import { SECCIONES_PLANEADOR, SEMANAS_PLANEADOR } from "../helper";
import { actualizarMensaje } from "../../../redux/actions/actGlobal";

const useStyles = makeStyles((theme) => ({
  page: {
    padding: theme.spacing(2, 0),
    boxSizing: "border-box",
    width: "100%",
  },
  top: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
    gap: theme.spacing(2),
  },
  title: {
    fontWeight: 900,
    letterSpacing: -0.3,
    textAlign: "right",
    lineHeight: 1.1,
  },
  fullWrap: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(0.5),
    width: "100%",
    boxSizing: "border-box",
  },
  fullView: {
    width: "100%",
    maxWidth: 980,
    borderRadius: 14,
    border: "1px solid rgba(0,0,0,0.08)",
    background: "#fff",
    padding: theme.spacing(2),
    boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
    boxSizing: "border-box",
  },
  compactHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  compactTitle: { fontWeight: 900, fontSize: 15, lineHeight: 1.1 },
  divider: { margin: theme.spacing(1.25, 0) },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "minmax(220px, 260px) 1fr",
    columnGap: theme.spacing(3),
    rowGap: theme.spacing(1.5),
    alignItems: "start",
  },
  label: {
    color: theme.palette.text.secondary,
    fontWeight: 700,
    fontSize: 13,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingTop: 3,
  },
  value: {
    fontSize: 13,
    lineHeight: 1.6,
    color: theme.palette.text.primary,
    wordBreak: "break-word",
  },
  listBlock: { margin: 0, padding: 0, listStyle: "none" },
  listItem: { display: "flex", gap: 12, marginTop: 10 },
  dot: {
    width: 7,
    height: 7,
    borderRadius: 999,
    background: "rgba(0,0,0,0.28)",
    marginTop: 7,
    flex: "0 0 auto",
  },
  listText: { fontSize: 13, lineHeight: 1.6 },
  emptyText: { fontSize: 13, color: theme.palette.text.secondary },
  unitHint: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    lineHeight: 1.6,
    marginTop: 6,
  },
  paneCard: {
    borderRadius: 14,
    border: "1px solid rgba(0,0,0,0.08)",
    background: "#fff",
    padding: theme.spacing(1.5, 2),
    minWidth: 0,
    boxSizing: "border-box",
    boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
  },
  unitMetaRow: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1.25),
  },
  unitMetaTitle: { fontWeight: 900, fontSize: 15 },
  unitMetaRight: {
    fontSize: 13,
    fontWeight: 700,
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
  },
  readBlock: { marginTop: theme.spacing(1) },
  readLabel: { fontSize: 13, fontWeight: 900, marginBottom: 6 },
  readValue: {
    fontSize: 13,
    lineHeight: 1.6,
    color: theme.palette.text.primary,
    background: "rgba(0,0,0,0.02)",
    border: "1px solid rgba(0,0,0,0.08)",
    borderRadius: 10,
    padding: theme.spacing(1.25),
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: theme.spacing(1.25),
  },
  formActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1.5),
  },
}));

export default function AsignaturaPlaneador({ handleRegresar, idPlanSyll, esDocente }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [infoAsignatura, setInfoAsignatura] = useState(null);
  const [planId, setPlanId] = useState(null);
  const [planAsignaturaId, setPlanAsignaturaId] = useState(null); // ADMIN
  const [planeadorEjecucionIdState, setPlaneadorEjecucionIdState] = useState(null); // DOCENTE
  const [view, setView] = useState("menu");
  const [cargando, setCargando] = useState(true);
  const [cargandoSecciones, setCargandoSecciones] = useState(false);
  const [cargandoInfoGeneral, setCargandoInfoGeneral] = useState(false);
  const [cargandoUnidad, setCargandoUnidad] = useState(false);
  const [cargandoSemanas, setCargandoSemanas] = useState(false);
  const [cargandoIndicadores, setCargandoIndicadores] = useState(false);
  const [infoGeneral, setInfoGeneral] = useState(null);
  const [secciones, setSecciones] = useState([]);
  const [selectedUnitKey, setSelectedUnitKey] = useState(null);
  const [selectedCorteCodigo, setSelectedCorteCodigo] = useState(null);
  const [selectedWeekNumber, setSelectedWeekNumber] = useState(null);
  const [semanasPorUnidad, setSemanasPorUnidad] = useState({
    u1: [],
    u2: [],
    u3: [],
  });
  const [unidadState, setUnidadState] = useState(() => ({
    u1: {
      unidadId: null,
      corte: "NO REGISTRA",
      nombreUnidad: "NO REGISTRA",
      resultadoAprendizaje: "NO REGISTRA",
      semanas: {},
    },
    u2: {
      unidadId: null,
      corte: "NO REGISTRA",
      nombreUnidad: "NO REGISTRA",
      resultadoAprendizaje: "NO REGISTRA",
      semanas: {},
    },
    u3: {
      unidadId: null,
      corte: "NO REGISTRA",
      nombreUnidad: "NO REGISTRA",
      resultadoAprendizaje: "NO REGISTRA",
      semanas: {},
    },
  }));
  const [indicadores, setIndicadores] = useState([]);
  const [progresoMenu, setProgresoMenu] = useState({});
  const [progresoSemanas, setProgresoSemanas] = useState({});
  const [unidadIdPorKey, setUnidadIdPorKey] = useState({
    u1: null,
    u2: null,
    u3: null,
  });
  const [observaciones, setObservaciones] = useState("");
  const [cargandoObs, setCargandoObs] = useState(false);
  const [guardandoObs, setGuardandoObs] = useState(false);
  const [ciaNivel, setCiaNivel] = useState("");
  const [ciaComponente, setCiaComponente] = useState("");
  const [ciaEstrategia, setCiaEstrategia] = useState("");
  const [savingCIA, setSavingCIA] = useState(false);
  const planeadorEjecucionId = esDocente ? idPlanSyll.planeadorEjecucionId : null;
  const planeadorBaseId = esDocente ? idPlanSyll.planeadorBaseId : null;
  const infoPlanAsignatura = esDocente ? idPlanSyll.planAsignatura : null;

  const obtenerInfoSyllabus = useCallback((asignatura) => {
    return new Promise((resolve) => {
      consulta(
        `api/v1.0/sisef/plan-asignatura/${asignatura}/`,
        null,
        null,
        (error, estado, resp) => resolve(estado === 200 && !error ? resp : null)
      );
    });
  }, []);

  const obtenerInfoGeneralPlan = useCallback((id, esDocente) => {
    const modo = esDocente ? "?modo=ejecucion" : "";
    return new Promise((resolve) => {
      consulta(
        `api/v1.0/sisef/listar/InfoGeneralPlan/${id}${modo}`,
        null,
        null,
        (error, estado, resp) =>
          resolve(estado === 200 && !error ? resp : null)
      );
    });
  }, []);

  const obtenerCIA = useCallback(
    (idPlan, esDocente) => {
      const modo = esDocente ? "?modo=ejecucion" : "";
      return new Promise((resolve) => {
        consulta(
          `api/v1.0/sisef/planeador/info-general/${idPlan}${modo}`,
          null,
          null,
          (error, estado, resp) =>
            resolve(!error && estado === 200 ? resp : null)
        );
      });
    },
    []
  );

  const guardarCIA = useCallback(
    (payload, esDocente) => {
      return new Promise((resolve) => {
        const data = new FormData();
        Object.entries(payload).forEach(([k, v]) => {
          if (v !== null && v !== undefined) data.append(k, v);
        });
        const modo = esDocente ? "?modo=ejecucion" : "";
        formulario(
          `api/v1.0/sisef/planeador/info-general${modo}`,
          data,
          "post",
          (error, estado, resp) => {
            let titulo = "Ha ocurrido un error, contacte con el administrador.",
              tipo = "error";
            const ok = !error && (estado === 200 || estado === 201);
            if (!error) {
              if (ok) {
                tipo = "success";
                titulo = resp?.titulo;
              } else {
                tipo = "info";
                titulo = resp?.titulo ? resp.titulo : mostrarError(resp);
              }
            }
            dispatch(
              actualizarMensaje({
                titulo,
                tipo,
                mostrar: true,
                tiempo: 6000,
              })
            );
            resolve(ok);
          }
        );
      });
    },
    [dispatch]
  );

  const obtenerUnidadesPorCorte = useCallback(
    (idPlanParam, codigoCorte, esDocente) => {
      const modo = esDocente ? "?modo=ejecucion" : "";
      return new Promise((resolve) => {
        consulta(
          `api/v1.0/sisef/listar/unidades-plan/${idPlanParam}/${codigoCorte}${modo}`,
          null,
          null,
          (error, estado, resp) =>
            resolve(!error && estado === 200 ? resp : null)
        );
      });
    },
    []
  );


  const obtenerSeccionesPlaneador = useCallback(async () => {
    setCargandoSecciones(true);
    try {
      const resp = await obtenerValoresFiltros([
        { llave: "generica", valor: SECCIONES_PLANEADOR },
        { llave: "estado", valor: "1" },
      ]);
      const valores = Array.isArray(resp) ? resp : [];
      valores.sort((a, b) => Number(a?.valora || 0) - Number(b?.valora || 0));
      setSecciones(valores);
    } catch (e) {
      console.error(e);
      setSecciones([]);
    } finally {
      setCargandoSecciones(false);
    }
  }, []);

  const obtenerSemanasPorUnidad = useCallback((unidadCodigo) => {
    return new Promise((resolve) => {
      obtenerPermisosValorAlt([
        { llave: "principal__codigo", valor: unidadCodigo },
        { llave: "estado", valor: 1 },
        { llave: "secundario__generica", valor: SEMANAS_PLANEADOR },
        { llave: "secundario__estado", valor: 1 },
      ])
        .then((resp) => resolve(Array.isArray(resp) ? resp : []))
        .catch(() => resolve([]));
    });
  }, []);

  const obtenerIndicadores = useCallback((unidadId) => {
    return new Promise((resolve) => {
      consulta(
        `api/v1.0/sisef/listar_indicadores/${unidadId}/ind_dsp`,
        null,
        null,
        (error, estado, resp) => resolve(!error && estado === 200 ? resp : [])
      );
    });
  }, []);

  const obtenerIndicadorEstrategias = useCallback(
    ({ unidadId, planId, indicadorId, esDocente }) => {
      const modo = esDocente ? "&modo=ejecucion" : "";
      return new Promise((resolve) => {
        consulta(
          `api/v1.0/sisef/planeador/indicador-estrategias?unidad_id=${unidadId}&plan_id=${planId}&indicador_id=${indicadorId}${modo}`,
          null,
          null,
          (error, estado, resp) =>
            resolve(!error && estado === 200 ? resp : null)
        );
      });
    },
    []
  );

  const obtenerProgreso = useCallback((planIdParam, unidadId, esDocente) => {
    const modo = esDocente ? "&modo=ejecucion" : "";
    const url = unidadId
      ? `api/v1.0/sisef/planeador/progreso/${planIdParam}?unidad_id=${unidadId}${modo}`
      : `api/v1.0/sisef/planeador/progreso/${planIdParam}?${modo.replace("&", "")}`;
    return new Promise((resolve) => {
      consulta(url, null, null, (error, estado, resp) =>
        resolve(!error && estado === 200 ? resp : null)
      );
    });
  }, []);

  const obtenerSemanasGuardadas = useCallback(
    (planIdParam, unidadId, esDocente) => {
      const modo = esDocente ? "?modo=ejecucion" : "";
      return new Promise((resolve) => {
        consulta(
          `api/v1.0/sisef/planeador/base/semana/listar/${planIdParam}/${unidadId}${modo}`,
          null,
          null,
          (error, estado, resp) =>
            resolve(!error && estado === 200 ? resp : [])
        );
      });
    },
    []
  );

  useEffect(() => {
    (async () => {
      try {
        setCargando(true);
        if (esDocente) {
          setInfoAsignatura(infoPlanAsignatura);
          setPlanId(planeadorEjecucionId);
        } else {
          const resp = await obtenerInfoSyllabus(idPlanSyll);
          setInfoAsignatura(resp ?? null);
          setPlanId(resp?.id ?? null);
        }
      } catch (e) {
        console.error("ERROR useEffect init:", e);
        setInfoAsignatura(null);
        setPlanId(null);
      } finally {
        setCargando(false);
      }
    })();
  }, [esDocente, idPlanSyll, planeadorEjecucionId, infoPlanAsignatura]);

  useEffect(() => {
    if (view === "menu") obtenerSeccionesPlaneador();
  }, [view, obtenerSeccionesPlaneador]);

  useEffect(() => {
    if (view !== "menu") return;
    if (!planId) return;
    (async () => {
      const resp = await obtenerProgreso(planId, null, esDocente);
      const map = {};
      (resp?.unidades || []).forEach((u) => {
        map[u.unidad_id] = {
          guardadas: u.guardadas || 0,
          total: u.total_semanas || 0,
          semanas: u.semanas || [],
        };
      });
      map.obs_plan = Boolean(resp?.observaciones);
      map.general_plan = Boolean(resp?.info_general);
      setProgresoMenu(map);
    })();
  }, [view, planId]);

  const selectedUnidadId = useMemo(() => {
    return unidadState?.[selectedUnitKey]?.unidadId || null;
  }, [unidadState, selectedUnitKey]);

  const selectedWeekData = useMemo(() => {
    if (!selectedUnitKey || !selectedWeekNumber) return null;
    const weekKey = `s${selectedWeekNumber}`;
    return unidadState?.[selectedUnitKey]?.semanas?.[weekKey] || null;
  }, [unidadState, selectedUnitKey, selectedWeekNumber]);

  const updateWeekField = (unitKey, weekNumber, field, value) => {
    const weekKey = `s${weekNumber}`;
    setUnidadState((prev) => ({
      ...prev,
      [unitKey]: {
        ...prev[unitKey],
        semanas: {
          ...prev[unitKey].semanas,
          [weekKey]: {
            ...prev[unitKey].semanas?.[weekKey],
            [field]: value,
          },
        },
      },
    }));
  };

  const handleClickInfoGeneral = useCallback(async () => {
    setCargandoInfoGeneral(true);
    setInfoGeneral(null);
    setView("general");
    try {
      const [respInfo, respCIA] = await Promise.all([
        obtenerInfoGeneralPlan(planId, esDocente),
        obtenerCIA(planId, esDocente),
      ]);
      setInfoGeneral(respInfo);
      setCiaNivel(respCIA?.nivel_cia ?? "");
      setCiaComponente(respCIA?.componente_cia ?? "");
      setCiaEstrategia(respCIA?.estrategia_didactica ?? "");
    } finally {
      setCargandoInfoGeneral(false);
    }
  }, [planId, obtenerInfoGeneralPlan, obtenerCIA]);

  const handleOpenUnit = useCallback((unitKey, codigoCorte) => {
    setSelectedUnitKey(unitKey);
    setSelectedCorteCodigo(codigoCorte);
    setSelectedWeekNumber(null);
    setView(unitKey);
  }, []);

  const handleOpenWeek = useCallback((unitKey, weekNumber) => {
    setSelectedUnitKey(unitKey);
    setSelectedWeekNumber(weekNumber);
    setView("week");
  }, []);

  const handleSelectIndicador = async (indicadorId) => {
    updateWeekField(selectedUnitKey, selectedWeekNumber, "indicador", indicadorId);
    const resp = await obtenerIndicadorEstrategias({
      unidadId: selectedUnidadId,
      planId,
      indicadorId,
      esDocente,
    });
    if (!resp?.estrategias) return;
    updateWeekField(selectedUnitKey, selectedWeekNumber, "estrategias", {
      presencial: resp.estrategias.presencial?.[0] || null,
      independiente: resp.estrategias.independiente?.[0] || null,
      evaluativa: resp.estrategias.evaluativa?.[0] || null,
    });
    const join = (arr) =>
      Array.isArray(arr)
        ? arr.map((x) => x?.nombre).filter(Boolean).join("\n")
        : "";
    updateWeekField(selectedUnitKey, selectedWeekNumber, "presencial", join(resp.estrategias.presencial));
    updateWeekField(selectedUnitKey, selectedWeekNumber, "independiente", join(resp.estrategias.independiente));
    updateWeekField(selectedUnitKey, selectedWeekNumber, "evaluacion", join(resp.estrategias.evaluativa));
  };

  const guardarSemana = useCallback(
    (payload, callback) => {
      consulta(
        `api/v1.0/sisef/planeador/base/semana/upsert`, payload, "post",
        (error, estado, resp) => {
          let titulo = "Ha ocurrido un error, contacte con el administrador.",
            tipo = "error";
          const ok = !error && (estado === 200 || estado === 201);
          if (!error) {
            if (ok) {
              tipo = "success";
              titulo = resp?.titulo;
            } else {
              tipo = "info";
              titulo = resp?.titulo ? resp.titulo : mostrarError(resp);
            }
          }
          dispatch(actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 }));
          callback(ok);
        }
      );
    },
    [dispatch]
  );

  const guardarSemanaEjecucion = useCallback(
    (payload, callback) => {
      consulta(
        `api/v1.0/sisef/planeador/ejecucion/semana/upsert/`,
        payload,
        "post",
        (error, estado, resp) => {
          let titulo = "Ha ocurrido un error, contacte con el administrador.",
            tipo = "error";
          const ok = !error && (estado === 200 || estado === 201);
          if (!error) {
            if (ok) {
              tipo = "success";
              titulo = resp?.titulo;
            } else {
              tipo = "info";
              titulo = resp?.titulo ? resp.titulo : mostrarError(resp);
            }
          }
          dispatch(
            actualizarMensaje({
              titulo,
              tipo,
              mostrar: true,
              tiempo: 6000,
            })
          );
          callback(ok);
        }
      );
    },
    [dispatch]
  );

  const handleSaveWeek = useCallback(
    async ({ selectedUnitKey: unitKey, selectedWeekNumber: weekNumber, estrategiasSemana }) => {
      const unidadId = unidadState?.[unitKey]?.unidadId;
      const semanas = semanasPorUnidad?.[unitKey] || [];
      const semanaObj = semanas.find((s) => Number(s?.valora || 0) === Number(weekNumber || 0));
      if (!planId || !unidadId || !semanaObj) return false;
      const weekKey = `s${weekNumber}`;
      const weekData = unidadState?.[unitKey]?.semanas?.[weekKey];
      if (!weekData) return false;
      const esEvaluacion = String(semanaObj?.valorb || "") === "1";
      let porcentajeEval = "";
      if (esEvaluacion) {
        const raw = semanaObj?.valorc;
        const p = raw === null || raw === undefined || raw === "" ? NaN : Number(raw);
        if (p !== 10 && p !== 20) {
          dispatch(
            actualizarMensaje({
              titulo:
                "La semana de evaluación no tiene porcentaje parametrizado (valor C). Debe ser 10 o 20.",
              tipo: "info",
              mostrar: true,
              tiempo: 6000,
            })
          );
          return false;
        }
        porcentajeEval = p;
      }

      const payload = {
        plan_id: planId,
        unidad_id: unidadId,
        semana_id: semanaObj.id,
        indicador_id: weekData.indicador || null,
        es_evaluacion: esEvaluacion ? 1 : 0,
        porcentaje_evaluacion: esEvaluacion ? porcentajeEval : "",
        estrategias: [
          {
            tipo: "est_sincr",
            estrategia_id: weekData.estrategias?.presencial?.id || null,
            realizada: estrategiasSemana.presencial.realizada,
            es_alternativa: estrategiasSemana.presencial.esAlternativa,
            descripcion_alternativa:
              estrategiasSemana.presencial.esAlternativa
                ? estrategiasSemana.presencial.descripcionAlternativa
                : "",
          },
          {
            tipo: "est_asincr",
            estrategia_id: weekData.estrategias?.independiente?.id || null,
            realizada: estrategiasSemana.independiente.realizada,
            es_alternativa: estrategiasSemana.independiente.esAlternativa,
            descripcion_alternativa:
              estrategiasSemana.independiente.esAlternativa
                ? estrategiasSemana.independiente.descripcionAlternativa
                : "",
          },
          {
            tipo: "est_eva",
            estrategia_id: weekData.estrategias?.evaluativa?.id || null,
            realizada: estrategiasSemana.evaluativa.realizada,
            es_alternativa: estrategiasSemana.evaluativa.esAlternativa,
            descripcion_alternativa:
              estrategiasSemana.evaluativa.esAlternativa
                ? estrategiasSemana.evaluativa.descripcionAlternativa
                : "",
          },
        ],
      };

      const savedOk = await new Promise((resolve) => {
        if (esDocente) {
          guardarSemanaEjecucion(
            {
              planeador_ejecucion_id: planId,
              semana_base_id: semanaObj.id,
              indicador_id: weekData.indicador || null,
              es_evaluacion: esEvaluacion ? 1 : 0,
              porcentaje_evaluacion: esEvaluacion ? porcentajeEval : "",
              estrategias: [
                {
                  tipo: "est_sincr",
                  estrategia_id: weekData.estrategias?.presencial?.id || null,
                  realizada: estrategiasSemana.presencial.realizada,
                  es_alternativa: estrategiasSemana.presencial.esAlternativa,
                  descripcion_alternativa:
                    estrategiasSemana.presencial.esAlternativa
                      ? estrategiasSemana.presencial.descripcionAlternativa
                      : "",
                },
                {
                  tipo: "est_asincr",
                  estrategia_id: weekData.estrategias?.independiente?.id || null,
                  realizada: estrategiasSemana.independiente.realizada,
                  es_alternativa: estrategiasSemana.independiente.esAlternativa,
                  descripcion_alternativa:
                    estrategiasSemana.independiente.esAlternativa
                      ? estrategiasSemana.independiente.descripcionAlternativa
                      : "",
                },
                {
                  tipo: "est_eva",
                  estrategia_id: weekData.estrategias?.evaluativa?.id || null,
                  realizada: estrategiasSemana.evaluativa.realizada,
                  es_alternativa: estrategiasSemana.evaluativa.esAlternativa,
                  descripcion_alternativa:
                    estrategiasSemana.evaluativa.esAlternativa
                      ? estrategiasSemana.evaluativa.descripcionAlternativa
                      : "",
                },
              ],
            },
            (ok) => resolve(Boolean(ok))
          );
        } else {
          guardarSemana(payload, (ok) => resolve(Boolean(ok)));
        }
      });

      if (!savedOk) return false;
      // PROGRESO SEMANAS
      const prog = await obtenerProgreso(planId, unidadId, esDocente);
      const doneMap = {};
      (prog?.semanas || []).forEach((s) => {
        doneMap[Number(s.n)] = Boolean(s.done);
      });
      setProgresoSemanas((prev) => ({ ...prev, [unitKey]: doneMap }));
      // PROGRESO MENÚ
      const resumen = await obtenerProgreso(planId, null, esDocente);
      const map = {};
      (resumen?.unidades || []).forEach((u) => {
        map[u.unidad_id] = {
          guardadas: u.guardadas || 0,
          total: u.total_semanas || 0,
          semanas: u.semanas || [],
        };
      });
      map.obs_plan = Boolean(resumen?.observaciones);
      map.general_plan = Boolean(resumen?.info_general);
      setProgresoMenu(map);
      setView(unitKey);
      return true;
    },
    [
      planId,
      unidadState,
      semanasPorUnidad,
      guardarSemana,
      obtenerProgreso,
      setProgresoSemanas,
      setProgresoMenu,
      setView,
      dispatch,
    ]
  );

  const handleClickObservaciones = useCallback(async () => {
    setCargandoObs(true);
    setObservaciones("");
    setView("obs");
    consulta(`api/v1.0/sisef/planeador/ejecucion/observaciones/listar/${planId}`, null, null, (error, estado, resp) => {
      if (!error && estado === 200) {
        setObservaciones(resp[0].observaciones || "");
      }
      setCargandoObs(false);
    });
  }, [planId]);

  const handleSaveObservaciones = useCallback(() => {
    if (!planId) return;
    setGuardandoObs(true);
    const data = new FormData();
    data.append("planeador_ejecucion_id ", planId);
    data.append("observaciones", observaciones || "");
    formulario(`api/v1.0/sisef/planeador/ejecucion/observaciones/upsert/`, data, "post", (error, estado, resp) => {
      setGuardandoObs(false);
      let titulo = "Ha ocurrido un error, contacte con el administrador.",
        tipo = "error";
      const ok = !error && (estado === 200 || estado === 201);
      if (!error) {
        if (ok) {
          tipo = "success";
          titulo = resp?.titulo;
        } else {
          tipo = "info";
          titulo = resp?.titulo ? resp.titulo : mostrarError(resp);
        }
      }
      dispatch(actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 }));
      if (ok) {
        setProgresoMenu((prev) => ({ ...prev, obs_plan: true }));
        setView("menu");
      }
    });
  }, [planId, observaciones, dispatch]);

  useEffect(() => {
    const isUnidadView = view === "u1" || view === "u2" || view === "u3";
    if (!isUnidadView) return;
    (async () => {
      try {
        setCargandoUnidad(true);
        const resp = await obtenerUnidadesPorCorte(
          planId,
          selectedCorteCodigo,
          esDocente
        );
        const unidadId = resp?.id_unidad ?? resp?.unidad_id ?? resp?.id ?? null;
        if (!unidadId) return;
        setUnidadState((prev) => ({
          ...prev,
          [selectedUnitKey]: {
            ...(prev[selectedUnitKey] || {}),
            unidadId,
            corte: resp?.corte || "NO REGISTRA",
            nombreUnidad: resp?.nombre_unidad || "NO REGISTRA",
            resultadoAprendizaje: resp?.resultado_aprendizaje || "NO REGISTRA",
          },
        }));
        const prog = await obtenerProgreso(planId, unidadId, esDocente);
        const doneMap = {};
        (prog?.semanas || []).forEach((s) => {
          doneMap[Number(s.n)] = Boolean(s.done);
        });
        setProgresoSemanas((prev) => ({ ...prev, [selectedUnitKey]: doneMap }));
        const guardadas = await obtenerSemanasGuardadas(planId, unidadId, esDocente);
        if (Array.isArray(guardadas) && guardadas.length > 0) {
          setUnidadState((prev) => {
            const semanasMap = {};
            guardadas.forEach((s) => {
              semanasMap[`s${s.semana_numero}`] = {
                indicador: s.indicador,
                estrategias: s.estrategias || null,
              };
            });
            return {
              ...prev,
              [selectedUnitKey]: {
                ...prev[selectedUnitKey],
                semanas: semanasMap,
              },
            };
          });
        }
      } catch (e) {
        console.error(e);
      } finally {
        setCargandoUnidad(false);
      }
    })();
  }, [
    view,
    planId,
    selectedCorteCodigo,
    selectedUnitKey,
    obtenerUnidadesPorCorte,
    obtenerProgreso,
    obtenerSemanasGuardadas,
  ]);

  useEffect(() => {
    const isUnidadView = view === "u1" || view === "u2" || view === "u3";
    if (!isUnidadView) return;
    (async () => {
      try {
        setCargandoSemanas(true);
        const permisos = await obtenerSemanasPorUnidad(selectedUnitKey);
        const semanas = permisos.map((p) => p?.secundario).filter(Boolean);
        semanas.sort((a, b) => Number(a?.valora || 0) - Number(b?.valora || 0));
        setSemanasPorUnidad((prev) => ({
          ...prev,
          [selectedUnitKey]: semanas,
        }));
      } catch (e) {
        console.error(e);
        setSemanasPorUnidad((prev) => ({ ...prev, [selectedUnitKey]: [] }));
      } finally {
        setCargandoSemanas(false);
      }
    })();
  }, [view, selectedUnitKey, obtenerSemanasPorUnidad]);

  useEffect(() => {
    if (view !== "week") return;
    (async () => {
      try {
        setCargandoIndicadores(true);
        if (!selectedUnidadId) {
          setIndicadores([]);
          return;
        }
        const resp = await obtenerIndicadores(selectedUnidadId);
        setIndicadores(Array.isArray(resp) ? resp : []);
      } catch (e) {
        console.error(e);
        setIndicadores([]);
      } finally {
        setCargandoIndicadores(false);
      }
    })();
  }, [view, selectedUnidadId, obtenerIndicadores]);

  const progresoPorOrden = useMemo(() => {
    const arr = [];
    Object.values(progresoMenu || {}).forEach((v) => {
      if (v?.total !== undefined) arr.push(v);
    });
    return arr;
  }, [progresoMenu]);

  const items = useMemo(() => {
    return (secciones || []).map((v) => {
      const codigo = v?.codigo;
      const codigoCorte = v?.valorb;
      const deshabilitada = !esDocente && v.valorb === "1"
      const onClick = () => {
        if (codigo === "general_plan") return handleClickInfoGeneral();
        if (codigo === "obs_plan") return handleClickObservaciones();
        if (codigo === "u1" || codigo === "u2" || codigo === "u3")
          return handleOpenUnit(codigo, codigoCorte);
      };
      const isUnidad = codigo === "u1" || codigo === "u2" || codigo === "u3";
      let subtitle = "";
      let done = false;
      if (isUnidad) {
        const index = codigo === "u1" ? 0 : codigo === "u2" ? 1 : 2;
        const prog = progresoPorOrden[index];
        const guardadas = prog?.guardadas || 0;
        const total = prog?.total || 0;
        subtitle = `${guardadas}/${total} semanas`;
        done = total > 0 && guardadas >= total;
      }
      if (codigo === "obs_plan") {
        done = Boolean(progresoMenu?.obs_plan);
      }
      if (codigo === "general_plan") {
        done = Boolean(progresoMenu?.general_plan);
      }
      return {
        key: `sec-${v?.id}`,
        title: v?.nombre,
        disabled: deshabilitada,
        icon:
          codigo === "general_plan" ? (
            <InfoOutlinedIcon />
          ) : codigo === "obs_plan" ? (
            <NotesOutlinedIcon />
          ) : (
            <SubjectOutlinedIcon />
          ),
        done,
        subtitle,
        onClick,
      };
    });
  }, [
    secciones,
    handleClickInfoGeneral,
    handleClickObservaciones,
    handleOpenUnit,
    unidadIdPorKey,
    progresoMenu,
    semanasPorUnidad,
  ]);

  const competenciasGenericas = useMemo(() => {
    const arr = infoGeneral?.competencias_genericas ?? [];
    return arr.map((x) => x?.competencia?.nombre).filter(Boolean);
  }, [infoGeneral]);

  const competenciasEspecificas = useMemo(() => {
    const arr = infoGeneral?.competencias_especificas ?? [];
    return arr.map((x) => x?.competencia).filter(Boolean);
  }, [infoGeneral]);

  const weekItemsForSelectedUnit = useMemo(() => {
    const semanas = semanasPorUnidad?.[selectedUnitKey] || [];
    const unidadId = unidadState?.[selectedUnitKey]?.unidadId;
    const progresoUnidad = unidadId ? progresoMenu?.[unidadId]?.semanas || [] : [];

    const progresoMap = {};
    progresoUnidad.forEach((s) => {
      progresoMap[Number(s.n)] = Boolean(s.done);
    });

    return semanas.map((s) => {
      const wkOrden = Number(s?.valora || 0);
      const isEval = String(s?.valorb || "") === "1";
      return {
        key: `wk-${s?.id}`,
        title: s?.nombre || `Semana ${wkOrden}`,
        done: Boolean(progresoMap[wkOrden]),
        subtitle: isEval ? "SEMANA DE EVALUACIÓN" : "Indicador · Actividades · Evaluación",
        onClick: () => handleOpenWeek(selectedUnitKey, wkOrden),
      };
    });
  }, [
    selectedUnitKey,
    semanasPorUnidad,
    unidadState,
    progresoMenu,
    handleOpenWeek,
  ]);

  const isSelectedWeekEvaluacion = useMemo(() => {
    const semanas = semanasPorUnidad?.[selectedUnitKey] || [];
    const wk = Number(selectedWeekNumber || 0);
    const found = semanas.find((s) => Number(s?.valora || 0) === wk);
    return String(found?.valorb || "") === "1";
  }, [semanasPorUnidad, selectedUnitKey, selectedWeekNumber]);

  if (cargando) {
    return (<TareasTerminadas mensaje="Cargando asignatura..." marginTop="7%" imagen={emma_s1} widthImg="7%" cargando />);
  }

  if (cargandoSecciones && view === "menu") {
    return (<TareasTerminadas mensaje="Cargando secciones del planeador..." marginTop="7%" imagen={emma_s1} widthImg="7%" cargando />);
  }

  if (cargandoInfoGeneral && view === "general") {
    return (<TareasTerminadas mensaje="Cargando información general..." marginTop="7%" imagen={emma_s1} widthImg="7%" cargando />);
  }

  if (cargandoUnidad || cargandoSemanas) {
    return (<TareasTerminadas mensaje="Cargando información de la unidad..." marginTop="7%" imagen={emma_s1} widthImg="7%" cargando />);
  }

  if (cargandoIndicadores && view === "week") {
    return (<TareasTerminadas mensaje="Cargando indicadores..." marginTop="7%" imagen={emma_s1} widthImg="7%" cargando />);
  }

  if (cargandoObs && view === "obs") {
    return (<TareasTerminadas mensaje="Cargando observaciones..." marginTop="7%" imagen={emma_s1} widthImg="7%" cargando />);
  }

  const hideTopBar = false;
  const sinPlan =
    !cargando &&
    !planId &&
    view === "menu";

  return (
    <div className={classes.page}>
      <PlaneadorShell>
        <PlaneadorTopBar
          classes={classes}
          title={infoAsignatura?.asignatura_nombre || "Asignatura"}
          onHome={() => handleRegresar()}
          onBack={() => {
            if (view === "menu") return handleRegresar("inicio");
            if (view === "week" && selectedUnitKey) return setView(selectedUnitKey);
            setView("menu");
          }}
          hide={hideTopBar}
        />

        {sinPlan && (
          <TareasTerminadas
            mensaje="No hay información registrada en el plan de asignatura."
            marginTop="7%"
            imagen={emma_s1}
            widthImg="7%"
            cargando={false}
          />
        )}

        {view === "menu" && !sinPlan && (
          <PlaneadorMenuView classes={classes} infoAsignatura={infoAsignatura} items={items} />
        )}

        {view === "general" && !sinPlan && (
          <PlaneadorInfoGeneralView
            classes={classes}
            cargandoInfoGeneral={cargandoInfoGeneral}
            infoGeneral={infoGeneral}
            competenciasGenericas={competenciasGenericas}
            competenciasEspecificas={competenciasEspecificas}
            emmaImg={emma_s1}
            TareasTerminadasComponent={TareasTerminadas}
            ciaNivel={ciaNivel}
            ciaComponente={ciaComponente}
            ciaEstrategia={ciaEstrategia}
            onChangeCiaNivel={setCiaNivel}
            onChangeCiaComponente={setCiaComponente}
            onChangeCiaEstrategia={setCiaEstrategia}
            onSaveCIA={async () => {
              if (!planId) return;
              setSavingCIA(true);
              const ok = await guardarCIA(
                {
                  plan_id: planId,
                  nivel_cia: ciaNivel || "",
                  componente_cia: ciaComponente || "",
                  estrategia_didactica: ciaEstrategia || "",
                },
                esDocente
              );
              setSavingCIA(false);
              if (ok) setView("menu");
            }}
            savingCIA={savingCIA}
          />
        )}

        {(view === "u1" || view === "u2" || view === "u3") && !sinPlan && (
          <PlaneadorUnidadView
            classes={classes}
            unitKey={view}
            unidadState={unidadState}
            weekItemsForSelectedUnit={weekItemsForSelectedUnit}
          />
        )}

        {view === "week" && !sinPlan && (
          <PlaneadorSemanaView
            classes={classes}
            selectedUnitKey={selectedUnitKey}
            selectedWeekNumber={selectedWeekNumber}
            selectedWeekData={selectedWeekData}
            isSelectedWeekEvaluacion={isSelectedWeekEvaluacion}
            updateWeekField={updateWeekField}
            onHome={() => handleRegresar()}
            onBack={() => {
              if (view === "menu") return handleRegresar("inicio");
              if (view === "week" && selectedUnitKey) return setView(selectedUnitKey);
              setView("menu");
            }}
            onBackToUnit={() => setView(selectedUnitKey)}
            cargandoIndicadores={cargandoIndicadores}
            indicadores={indicadores}
            onSaveWeek={handleSaveWeek}
            onSelectIndicador={handleSelectIndicador}
          />
        )}

        {view === "obs" && !sinPlan && (
          <PlaneadorObservacionesView
            classes={classes}
            value={observaciones}
            onChange={setObservaciones}
            onBack={() => setView("menu")}
            onSave={handleSaveObservaciones}
            saving={guardandoObs}
          />
        )}
      </PlaneadorShell>
    </div>
  );
}
